import { styled } from "@mui/material";
import theme from "themes/theme";

export const LeftTileWrapperSC = styled("div")({
  backgroundColor: theme.palette.background.paper,
  margin: "36px 0",
  padding: "30px",
  minWidth: "fit-content",
});
